import React from 'react';

interface TikTokIconProps {
  className?: string;
}

const TikTokIcon: React.FC<TikTokIconProps> = ({ className }) => (
  <i
    className={['fa-brands fa-tiktok', className].filter(Boolean).join(' ')}
    aria-hidden="true"
  />
);

export default TikTokIcon;
